const autocompleteModalPlace = {
  site: 'Sitios'
};

export default autocompleteModalPlace;
